import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Element } from 'react-scroll';
import { propBool, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import InputError from '../../../../../../Ui/Common/InputError';
import PlainInput from '../../../../../../Ui/Common/PlainInput';
/**
 * セミナーのタイトル入力コンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneFormApplicationUrlField = (props) => {
    const { className, disabled, input, meta } = props;
    const hasError = meta.touched && meta.error;
    return (_jsx(Element, Object.assign({ className: className, name: `${input.name}_view` }, { children: _jsx("div", Object.assign({ className: 'professional_seminar_one_form_application_url' }, { children: _jsxs("div", Object.assign({ className: 'application_url_inner field' }, { children: [_jsx(PlainInput, { className: 'application_url_input', disabled: disabled, input: input, meta: meta }), hasError ? (_jsx(InputError, { meta: meta })) : (_jsx("div", Object.assign({ className: 'application_url_description text-liststyle' }, { children: "\u81EA\u793E\u306E\u30BB\u30DF\u30CA\u30FC\u30DA\u30FC\u30B8\u306EURL\u3092\u5165\u529B\u304F\u3060\u3055\u3044" })))] })) })) })));
};
SeminarOneFormApplicationUrlField.propTypes = {
    className: propStr(),
    disabled: propBool(),
    input: propShape().isRequired,
    meta: propShape().isRequired,
};
SeminarOneFormApplicationUrlField.defaultProps = {
    className: '',
    disabled: false,
};
export default SeminarOneFormApplicationUrlField;
